import React from "react";
import {Typography} from "antd";
import {ChartBox} from "../../Modeling/ChartBox";
import {formatValue, numberFormat, tokens} from "./tokens";

/**
 * Подсказка на графике: год крупно, ряды — цветными строками с выравненными
 * значениями. Стандартная подсказка recharts даёт неформатированные числа
 * и не различает единицы измерения.
 */
export const ChartHint = ({active, payload, label, unit}) => {
    if (!active || !payload?.length) return null

    return (
        <div className={"chart-hint"}>
            <div className={"chart-hint__label"}>{label}</div>
            {payload.filter(item => item.value !== undefined && item.value !== null).map(item => (
                <div className={"chart-hint__row"} key={item.dataKey}>
                    <span className={"chart-hint__marker"} style={{background: item.color || item.stroke}}/>
                    <span className={"chart-hint__name"}>{item.name}</span>
                    <span className={"chart-hint__value"}>{formatValue(item.value, unit)}</span>
                </div>
            ))}
        </div>
    )
}

/** Настройки легенды: компактная строка под заголовком графика. */
export const legendProps = {
    verticalAlign: 'top',
    align: 'left',
    height: 34,
    iconType: 'circle',
    iconSize: 8,
    wrapperStyle: {fontSize: 11, color: tokens.muted, lineHeight: 1.5, paddingBottom: 6},
}

/**
 * Рамка графика: заголовок, необязательная сводка справа и сам график
 * в адаптивном контейнере.
 */
export const ChartFrame = ({title, hint, summary, aspect = 1.7, minHeight = 200, children}) => (
    <div className={"chart-frame"}>
        <div className={"chart-frame__head"}>
            <div>
                <Typography.Text className={"chart-frame__title"}>{title}</Typography.Text>
                {hint && <Typography.Text type={"secondary"} className={"chart-frame__hint"}>{hint}</Typography.Text>}
            </div>
            {summary !== undefined && summary !== null &&
                <span className={"chart-frame__summary"}>
                    {typeof summary === 'number' ? numberFormat.format(Math.round(summary)) : summary}
                </span>}
        </div>
        <ChartBox aspect={aspect} minHeight={minHeight}>{children}</ChartBox>
    </div>
)

export default ChartFrame
